// CarbohydrateCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Karbohidrat Elektronik - Pelajari Cara Menghitung Karbohidrat";
const DESCRIPTION =
  "Kalkulator karbohidrat membantu Anda menstabilkan, menurunkan, atau menambah berat badan. Kalkulator karbohidrat adalah alat berharga yang membantu individu menentukan persentase karbohidrat optimal yang harus mereka konsumsi setiap hari.";
const KEYWORDS = "karbohidrat, hitung karbohidrat";
const OG_URL = "https://do-calculate.com/calculator/id/carbohydrate/";
function CarbohydrateCalculator() {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [activity, setActivity] = useState("");
  const [result, setResult] = useState(null);
  const calculateCarbohydrates = () => {
    const genderFactor = gender === "male" ? 5 : -161;
    const calories = Math.round(
      10 * weight + 6.25 * height - 5 * age + genderFactor
    );
    const activityFactors = {
      sedentary: 1.2,
      lightlyActive: 1.375,
      moderatelyActive: 1.55,
      active: 1.725,
      veryActive: 1.9,
    };
    const tdee = calories * activityFactors[activity];
    const tdee_lose_0_5 = calories * activityFactors[activity] - 500;
    const tdee_lose_1 = calories * activityFactors[activity] - 1000;
    const tdee_gain_0_5 = calories * activityFactors[activity] + 500;
    const tdee_gain_1 = calories * activityFactors[activity] + 1000;
    const carbs40 = Math.round((tdee * 0.4) / 3.75);
    const carbs55 = Math.round((tdee * 0.55) / 3.75);
    const carbs65 = Math.round((tdee * 0.65) / 3.75);
    const carbs75 = Math.round((tdee * 0.75) / 3.75);
    const carbs40Lose0_5 = Math.round((tdee_lose_0_5 * 0.4) / 3.75);
    const carbs55Lose0_5 = Math.round((tdee_lose_0_5 * 0.55) / 3.75);
    const carbs65Lose0_5 = Math.round((tdee_lose_0_5 * 0.65) / 3.75);
    const carbs75Lose0_5 = Math.round((tdee_lose_0_5 * 0.75) / 3.75);
    const carbs40Lose1 = Math.round((tdee_lose_1 * 0.4) / 3.75);
    const carbs55Lose1 = Math.round((tdee_lose_1 * 0.55) / 3.75);
    const carbs65Lose1 = Math.round((tdee_lose_1 * 0.65) / 3.75);
    const carbs75Lose1 = Math.round((tdee_lose_1 * 0.75) / 3.75);
    const carbs40Gain0_5 = Math.round((tdee_gain_0_5 * 0.4) / 3.75);
    const carbs55Gain0_5 = Math.round((tdee_gain_0_5 * 0.55) / 3.75);
    const carbs65Gain0_5 = Math.round((tdee_gain_0_5 * 0.65) / 3.75);
    const carbs75Gain0_5 = Math.round((tdee_gain_0_5 * 0.75) / 3.75);
    const carbs40Gain1 = Math.round((tdee_gain_1 * 0.4) / 3.75);
    const carbs55Gain1 = Math.round((tdee_gain_1 * 0.55) / 3.75);
    const carbs65Gain1 = Math.round((tdee_gain_1 * 0.65) / 3.75);
    const carbs75Gain1 = Math.round((tdee_gain_1 * 0.75) / 3.75);
    return {
      goal: "Pemeliharaan Berat Badan",
      calories: tdee,
      carbs40,
      carbs55,
      carbs65,
      carbs75,
      carbs40Lose0_5,
      carbs55Lose0_5,
      carbs65Lose0_5,
      carbs75Lose0_5,
      carbs40Lose1,
      carbs55Lose1,
      carbs65Lose1,
      carbs75Lose1,
      carbs40Gain0_5,
      carbs55Gain0_5,
      carbs65Gain0_5,
      carbs75Gain0_5,
      carbs40Gain1,
      carbs55Gain1,
      carbs65Gain1,
      carbs75Gain1,
      tdee_lose_0_5,
      tdee_lose_1,
      tdee_gain_0_5,
      tdee_gain_1,
    };
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = calculateCarbohydrates();
    setResult(result);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator karbohidrat membantu Anda menstabilkan, menurunkan, atau menambah berat badan. Kalkulator karbohidrat adalah alat berharga yang membantu individu menentukan persentase karbohidrat optimal yang harus mereka konsumsi setiap hari. Karbohidrat adalah sumber energi penting dalam makanan, dan memainkan peran besar dalam memenuhi kebutuhan tubuh sehari-hari. Jika karbohidrat dikonsumsi dengan tepat, mereka dapat membantu menjaga tingkat energi dan kinerja fisik. Kalkulator karbohidrat didasarkan pada banyak faktor seperti usia, jenis kelamin, tingkat aktivitas fisik, dan tujuan kesehatan pribadi. Dengan memasukkan informasi ini, individu dapat menerima panduan yang dipersonalisasi tentang berapa banyak karbohidrat yang harus mereka sertakan dalam diet mereka setiap hari.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Hitung Karbohidrat dalam Tubuh
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="height" className="form-label ms-2">
                        Tinggi Badan
                      </label>
                    </b>
                    <input
                      type="number"
                      id="weightNumber"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                      className="form-control ml-2"
                      style={{ width: "90%" }}
                      placeholder="175"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">cm</span>
                    </div>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="weightNumber" className="form-label ms-2">
                        Berat Badan
                      </label>
                    </b>
                    <input
                      type="number"
                      id="weightNumber"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                      className="form-control ml-2"
                      style={{ width: "90%" }}
                      placeholder="65"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">kg</span>
                    </div>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="age" className="form-label ms-2">
                        Usia
                      </label>
                    </b>
                    <input
                      type="number"
                      id="age"
                      value={age}
                      onChange={(e) => setAge(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="6"
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label >Jenis Kelamin</label>
                    </b>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="gender"
                        value="male"
                        id="male"
                        checked={gender === "male"}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-check-input"
                      />
                      <label className="form-check-label" htmlFor="male">
                        Laki-laki
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="gender"
                        value="female"
                        id="female"
                        checked={gender === "female"}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-check-input"
                      />
                      <label className="form-check-label" htmlFor="female">
                        Perempuan
                      </label>
                    </div>
                  </div>
                  <br />
                  <div>
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="activitySelect"
                      >
                        Tingkat Aktivitas
                      </label>
                    </b>
                    <select
                      id="activitySelect"
                      className="form-select"
                      value={activity}
                      onChange={(e) => setActivity(e.target.value)}
                    >
                      <option value="">-- Pilih Aktivitas --</option>
                      <option value="sedentary">
                        Kurang Aktif: aktivitas fisik sangat sedikit atau tidak ada olahraga
                      </option>
                      <option value="lightlyActive">
                        Cukup Aktif: olahraga ringan atau aktivitas fisik 1-3 hari per minggu
                      </option>
                      <option value="moderatelyActive">
                        Aktif Sedang: olahraga sedang atau aktivitas fisik 3-5 hari per minggu
                      </option>
                      <option value="active">
                        Aktif Tinggi: olahraga intens atau aktivitas fisik 6-7 hari per minggu
                      </option>
                      <option value="veryActive">
                        Sangat Aktif: olahraga sangat intens atau aktivitas fisik berat setiap hari
                      </option>
                    </select>
                  </div>
                  <br />
                  <hr />
                  <button
                    type="submit"
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                  >
                    Hitung
                  </button>
                </form>
              </div>
              <div className="col-12 col-md-7">
                {result && (
                  <table >
                    <thead>
                      <tr>
                        <th >Target</th>
                        <th >Kalori Harian</th>
                        <th >40%</th>
                        <th >55%</th>
                        <th >65%</th>
                        <th >75%</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Mempertahankan Berat Badan</td>
                        <td>{result.calories} kalori</td>
                        <td>{result.carbs40} g</td>
                        <td>{result.carbs55} g</td>
                        <td>{result.carbs65} g</td>
                        <td>{result.carbs75} g</td>
                      </tr>
                      <tr>
                        <td>Penurunan 0,5 kg/minggu</td>
                        <td>{result.tdee_lose_0_5} kalori</td>
                        <td>{result.carbs40Lose0_5} g</td>
                        <td>{result.carbs55Lose0_5} g</td>
                        <td>{result.carbs65Lose0_5} g</td>
                        <td>{result.carbs75Lose0_5} g</td>
                      </tr>
                      <tr>
                        <td>Penurunan 1 kg/minggu</td>
                        <td>{result.tdee_lose_1} kalori</td>
                        <td>{result.carbs40Lose1} g</td>
                        <td>{result.carbs55Lose1} g</td>
                        <td>{result.carbs65Lose1} g</td>
                        <td>{result.carbs75Lose1} g</td>
                      </tr>
                      <tr>
                        <td>Kenaikan 0,5 kg/minggu</td>
                        <td>{result.tdee_gain_0_5} kalori</td>
                        <td>{result.carbs40Gain0_5} g</td>
                        <td>{result.carbs55Gain0_5} g</td>
                        <td>{result.carbs65Gain0_5} g</td>
                        <td>{result.carbs75Gain0_5} g</td>
                      </tr>
                      <tr>
                        <td>Kenaikan 1 kg/minggu</td>
                        <td>{result.tdee_gain_1} kalori</td>
                        <td>{result.carbs40Gain1} g</td>
                        <td>{result.carbs55Gain1} g</td>
                        <td>{result.carbs65Gain1} g</td>
                        <td>{result.carbs75Gain1} g</td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
                        <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Semua yang Perlu Anda Ketahui tentang Karbohidrat: Cara Menghitungnya dan Pentingnya dalam Diet Anda:
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Semua yang Perlu Anda Ketahui tentang Karbohidrat: Cara Menghitungnya dan Pentingnya dalam Diet Anda
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Karbohidrat adalah salah satu komponen dasar makanan, dan memainkan peran penting dalam menyediakan energi bagi tubuh dan mempertahankan fungsi vitalnya. Dalam artikel ini, kita akan menjelajahi dunia karbohidrat dan belajar cara menghitungnya secara akurat serta pentingnya dalam diet Anda.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Konsep Karbohidrat</h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Karbohidrat adalah senyawa kimia yang terdiri dari karbon, hidrogen, dan oksigen. Karbohidrat termasuk gula, pati, dan serat, dan ditemukan dalam banyak makanan seperti roti, nasi, buah-buahan, dan sayuran.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menghitung Karbohidrat{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Ada kebutuhan yang meningkat untuk mengetahui jumlah karbohidrat yang harus Anda konsumsi setiap hari, untuk mencapai keseimbangan yang sehat dalam diet Anda. Karbohidrat dapat dihitung dengan melacak label makanan pada kemasan dan menggunakan kalkulator karbohidrat yang tersedia online.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Pentingnya Karbohidrat dalam Makanan:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Singkatnya, karbohidrat adalah bagian penting dari diet Anda dan sangat penting untuk kesehatan Anda secara keseluruhan dan kinerja harian Anda. Dengan mengetahui cara menghitungnya dan memasukkannya secara tepat ke dalam makanan Anda, Anda dapat menikmati manfaatnya dengan lebih baik dan hidup sehat.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Berapa banyak karbohidrat yang harus Anda konsumsi?
                </h3>
              </div>
              <div className="info-section-body">
                Ada sejumlah faktor yang mempengaruhi jumlah karbohidrat yang kita butuhkan, termasuk individu, intensitas dan durasi olahraga, tetapi secara umum untuk atlet, 60-70 persen energi harus berasal dari karbohidrat. Latihan intensitas tinggi yang berlangsung 1-3 jam membutuhkan sekitar 6-10 gram per kg massa tubuh, dibandingkan dengan latihan intensitas rendah yang hanya membutuhkan 3-5 gram per kg massa tubuh. Asupan karbohidrat tergantung pada jenis, intensitas, dan durasi olahraga, di mana jumlah karbohidrat yang dikonsumsi meningkat seiring dengan peningkatan intensitas olahraga. Pelatihan dan perencanaan sangat membantu dalam membantu Anda menghitung jumlah karbohidrat yang akan Anda butuhkan selama latihan Anda, karena penipisan karbohidrat akan menyebabkan tubuh menggunakan simpanan lemak dan protein sebagai bahan bakar, yang dapat menyebabkan pembakaran otot sebagai bahan bakar daripada makanan.{" "}
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana karbohidrat mempengaruhi pertumbuhan otot?
                </h3>
              </div>
              <div className="info-section-body">
                Beberapa orang berpikir bahwa untuk membangun otot dengan cepat, Anda harus mengorbankan karbohidrat untuk membakar lemak sebagai bahan bakar dan mengisi protein sebagai gantinya untuk membantu pertumbuhan otot. Ini benar ketika atlet mencoba untuk kurus untuk waktu yang singkat, tetapi sepanjang sebagian besar tahun, ketika mencoba membangun otot dan memperluas pertumbuhan, diet sedang hingga tinggi karbohidrat adalah pendekatan terbaik. Tingkat energi yang lebih tinggi, peningkatan dukungan otot, peningkatan tingkat pemulihan, dan pencegahan kerusakan otot semuanya dijamin saat mengonsumsi karbohidrat. Berlawanan dengan kepercayaan populer, karbohidrat dapat membantu pertumbuhan otot Anda membuatnya lebih kuat, dan pasti harus dimasukkan dalam diet Anda.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa yang terjadi ketika semua karbohidrat digunakan?
                </h3>
              </div>
              <div className="info-section-body">
                Kinerja Anda pertama-tama menurun ketika Anda melewatkan atau menghabiskan semua karbohidrat, dan gerakan serta stimulasi otot menjadi lebih sulit, yang kemudian dapat mempengaruhi kinerja. Ketika simpanan karbohidrat digunakan, tubuh akan menggunakan protein sebagai sumber energi, yang kemudian akan mempengaruhi kemampuannya untuk mendapatkan dan mendukung otot. Membakar protein sebagai energi dapat menyebabkan lebih banyak masalah, karena ketika tubuh Anda mencoba membuang produk sampingan protein, ginjal harus bekerja lebih keras, menyebabkan stres yang dapat merusaknya. Karbohidrat juga membantu memberi makan otak dan sistem saraf pusat, dan ketika Anda kehabisan karbohidrat, itu dapat mempengaruhi kinerja mereka dan dalam kasus yang parah dapat menyebabkan lebih banyak masalah.{" "}
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default CarbohydrateCalculator;
